/* eslint-disable */
!(function (a, b, c) {
  function g() {
    var i,
      a = f.clientWidth,
      b = f.clientHeight,
      d = e.standardWidth,
      g = e.standardHeight
    a >= d && (a = d),
      'function' == typeof c &&
      ((i = c(e) || {}), (a = i.clientWidth || a), (b = i.clientHeight || b)),
      (f.style.fontSize = h(a, b, d, g, e.standard) + 'px')
  }
  function h(a, b, c, d, f) {
    var g = e.standardFontSize
    return 'width' === f ? (g * a) / c : 'height' === f ? (g * b) / d : void 0
  }
  var e = {
    standardHeight: 667,
    standardWidth: 375,
    standard: a || 'width',
    standardFontSize: 37.5
  },
    f = document.documentElement
  b && window.addEventListener && window.addEventListener('resize', g, !1), g()
})('width', 1, detectOrient)

function replaceClass(classList, from, to) {
  classList.remove(from)
  classList.add(to)
}

/**
 * 参考
 * https://aotu.io/notes/2017/01/31/detect-orientation/index.html
 */
function detectOrient() {
  // const a ='Mozilla/5.0 (iPad; CPU OS 15_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/98.0.4758.97 Mobile/15E148 Safari/604.1'
  // const b ='Mozilla/5.0 (YDUIStyle/PAD; CPU OS 15_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/98.0.4758.97 Mobile/15E148 Safari/604.1'
  // var isIpad = Boolean(navigator.userAgent.match(/iPad/i))
  var isIpad = Boolean(navigator.userAgent.match(/iPad/i)) || Boolean(navigator.userAgent.match(/Macintosh/i)) || navigator.userAgent.indexOf('YDUIStyle/PAD') > -1
  if (isIpad) {
    var docEl = document.documentElement
    var cw = docEl.clientWidth
    var _Width = 0,
      _Height = 0
    docEl.classList.add('ipad')
    sw = window.screen.width
    sh = window.screen.height
    // 2.在某些机型（如华为P9）下出现 srceen.width/height 值交换，所以进行大小值比较判断
    _Width = sw < sh ? sw : sh
    _Height = sw >= sh ? sw : sh
    if (cw == _Width) {
      replaceClass(docEl.classList, 'landscape', 'portrait')
    }
    if (cw == _Height) {
      replaceClass(docEl.classList, 'portrait', 'landscape')
    }
    return {
      clientWidth: 375 * 1.12
    }
  }
}
